import {connect} from 'react-redux';
import {container} from 'op/container';
import {compose, defaultProps, withState, withHandlers, lifecycle} from 'recompose';

import {withAxios} from 'op/components/auth';
import url from "url";

export const withUnits = compose(
    withAxios,
    defaultProps({
        onReadinessSelect: () => {},
        onUnitSelect: () => {},
        onJobSelect: () => {},
        onClose: () => {}
    }),
    withState('loading', 'setLoading', false),
    connect((state) => ({
        units: state.lut.unit || [],
        jobs: state.lut.job || [],
    }), (dispatch) => ({
        setUnits: (units) => dispatch(container.resolve('actions').load_table({table: 'unit', payload: units})),
        setJobs: (jobs) => dispatch(container.resolve('actions').load_table({table: 'job', payload: jobs})),
    })),
    withHandlers({
        fetchUnits: ({axios, setUnits}) => () => {
            axios.get('/api/status/getAllUnits')
                .then(result =>
                    setUnits(result.data.map(container.resolve('transformers').unit))
                );
        },
        selectUnit: ({axios, setJobs, onUnitSelect, onJobSelect, setLoading}) => async (unit) => {
            if (unit) {
                setLoading(true);
                const {data: jobs} = await axios.get(url.format({
                    pathname: '/api/status/getUnitJobs',
                    query: {unitID: unit.id}
                }));
                setJobs(jobs.map(container.resolve('transformers').job));
                setLoading(false);
            }

            onUnitSelect(unit);
            onJobSelect(null);
        },
        setOpenModal: () => async () => {
            await container.resolve('persistor').purge();
        }
    }),
    lifecycle({
        componentDidMount() {
            if (this.props.online && this.props.units.length === 0)
                this.props.fetchUnits();
        }
    }),
);